import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { StorageKeys } from 'app/Shared/Constant/StorageKeys';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';
import { AuthServiceService } from './auth-service.service';

@Injectable(
	{providedIn: 'root'}
)
export class AuthguardGuard implements CanActivate {
	constructor(private authServiceService: AuthServiceService,
		private constantService: ConstantService,
		private messageService: MessageService,
		private userService: UserService,
		private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		if (this.authServiceService.getUserLoggedIn() === true || this.constantService.getSessionStorage(StorageKeys.User)) {
			let canFirmAccessURL = this.verifyFirmAccessibility(next);
			return canFirmAccessURL;
		}
	 	return false;
	}

	/* Check Firm Accessibility for Menu OR Submenu Screen */
	verifyFirmAccessibility(urlRouteParams: any) {
		if((urlRouteParams.routeConfig.path==="CAT" && this.userService.MPIDServiceList.catService==="false") || 
		   (urlRouteParams.routeConfig.path==="CAIS" && this.userService.MPIDServiceList.caisService==="false") ||
		   (urlRouteParams.routeConfig.path==="Reg-Reporting" && this.userService.MPIDServiceList.regReporting==="false" && !this.userService.isRoleSuperUser()) ||
		   (urlRouteParams.routeConfig.path==="Reg-MM-List" && this.userService.MPIDServiceList.regmmsymbolService==="false") ||
		   (urlRouteParams.routeConfig.path==="File Upload" && !this.userService.enableFileProcessing())) {
				this.messageService.add({ severity: 'error', summary: "Service Access", detail: (urlRouteParams.routeConfig.path + " service not available.") });
				return false;
		}
		return true;
	}

}